import template from './exploreFilters.jade';
import Rx from 'rx';

class ExploreFiltersController {
  constructor(playerExploreGenresOptions, $stateParams, yesNoOptions, countryCodesOptions, currentExploreGroup, userExploreConstants, currentGame, UserExplorerResource) {
    let controllerThis = this;
    this.$stateParams = $stateParams;
    this.playerExploreGenresOptions = playerExploreGenresOptions;
    this.UserExplorerResource = UserExplorerResource;
    this.yesNoOptions = yesNoOptions;
    this.countryCodesOptions = countryCodesOptions;
    this.currentExploreGroup = currentExploreGroup;
    this.userExploreConstants = userExploreConstants;
    this.appsOptions = [];
    this.overviewFiltersOpen = true;
    currentGame.subscribe(game => {
      this.acquisitionSourceOptions = game.simplaex_field_configs.acquisitionSource.possible_values
        .map(option => { return { value: option, name: option } });
    });

    this.populateAppsOptions();

    this.filtersHandler = {
      get: function(object, property) {
        return object[property];
      },
      set: function(obj, prop, value) {
        if(prop == 'registration_date' && obj[prop] && value) {
          if(obj[prop].getTime() === value.getTime() || moment.utc(value).hours() != 0) {
            //
            // Needed to avoid registration_date to be set twice, causing 2 API calls.
            // this happens because both 'monthpicker' and 'date-parser' set registration_date.
            // date-parser doesn't change the value but this setter is still called twice.
            //
            // this is a quick fix. we are preventing currentExploreGroup.onNext to be called with:
            // - a string value
            // - a value with UTC hours !=0
            return true;
          }
        }
        // The default behavior to store the value
        obj[prop] = value;
        controllerThis.currentExploreGroup.onNext(obj);
        // Indicate success
        return true;
      }
    };

    this.currentExploreGroup.subscribe((group) => {
      if(group != null) {
        this.filters = group;
        this.filtersProxy = new Proxy(this.filters, this.filtersHandler);
      }
    });


    this.activeDaysSlider = {
      start: [0], // this is just as a default value for the rendering before currentExploreGroup is is provided to the component
      tooltips: {
        format: ((value) => {
          return this.getTooltipString(value, 'activeDaysSliderTickToValue', '10.00');
        })
      },
      connect: 'upper',
      margin: 2,
      step: 1,
      range: {
        min: 1,
        max: 10
      }
    };

    this.sessionsPerDaySlider = {
      start: [0], // this is just as a default value for the rendering before currentExploreGroup is is provided to the component
      tooltips: {
        format: ((value) => {
          return this.getTooltipString(value, 'sessionsSliderTickToValue', '10.00');
        })
      },
      connect: 'upper',
      margin: 2,
      step: 1,
      range: {
        min: 1,
        max: 11
      }
    };


    this.otherAppsSlider = {
      start: [0], // this is just as a default value for the rendering before currentExploreGroup is is provided to the component
      tooltips: {
        format: ((value) => {
          return this.getTooltipString(value, 'otherAppsSliderTickToValue', '11.00');
        })
      },
      connect: 'upper',
      margin: 2,
      step: 1,
      range: {
        min: 1,
        max: 11
      }
    };

    this.paymentAmountSlider = {
      start: [0], // this is just as a default value for the rendering before currentExploreGroup is is provided to the component
      tooltips: {
        format: ((value) => {
          return this.getTooltipString(value, 'paymentAmountSliderTickToValue', '14.00');
        })
      },
      connect: 'upper',
      margin: 2,
      step: 1,
      range: {
        min: 1,
        max: 14
      }
    };

    this.transactionsSlider = {
      start: [0], // this is just as a default value for the rendering before currentExploreGroup is is provided to the component
      tooltips: {
        format: ((value) => {
          return this.getTooltipString(value, 'transactionsSliderTickToValue', '13.00');
        })
      },
      connect: 'upper',
      margin: 2,
      step: 1,
      range: {
        min: 1,
        max: 13
      }
    };

    this.ageSlider = {
      start: [0,0], // this is just as a default value for the rendering before currentExploreGroup is is provided to the component
      connect: true,
      tooltips: {
        format: ((value) => {
          if(value) {
            if (this.userExploreConstants.ageSliderTickToRange[value].from == this.userExploreConstants.ageSliderTickToRange[value].to) {
              return this.userExploreConstants.ageSliderTickToRange[value].from;
            } else {
              return this.userExploreConstants.ageSliderTickToRange[value].from + (value == '7.00' ? '+' : '');
            }
          }
        })
      },
      margin: 1,
      step: 1,
      range: {
        min: 1,
        max: 7
      }
    };
  }

  populateAppsOptions() {
    this.UserExplorerResource.one(this.$stateParams.gameId).customPOST({}, 'breakdown', {breakdown_dimension: 'APPS', topN: '50'}).then((res) => {
      _.forEach(res.breakdown, (app) => {
        this.appsOptions.push({value: app.dimension_value, name: app.app_name});
      });
    })
  }

  getTooltipString(value, tickToValueConfig, maxTickValue) {
    if(value) {
      if(value !== maxTickValue) {
        return this.userExploreConstants[tickToValueConfig][value].to
      } else {
        return this.userExploreConstants[tickToValueConfig][value].from + '+';
      }
    } else {
      return '';
    }
  }

  getSerializedFilters() {
    // remove transactions and payment amount if is_paying is false
  }
}

let ExploreFiltersComponent = {
  template: () => { return template },
  controller: ExploreFiltersController,
  controllerAs: 'vm',
  bindings: {}
};

export default angular.module('app.components.explore.filters', [])
  .component('exploreFilters', ExploreFiltersComponent);



/** WEBPACK FOOTER **
 ** ./src/components/explore/exploreFilters.js
 **/